export default "__VITE_ASSET__BYY7J3YU__"